module.exports = __webpack_public_path__ + "static/media/md-sunny.6d8661c3.svg";